import React from 'react'

const OfferPreview = () => {
  return (
    <div>OfferPreview</div>
  )
}

export default OfferPreview